<template>
  <div class="item-form-wrap">
    <!-- 允许加班 -->
    <el-form-item :label="$t('156')">
      <el-switch :active-value="1" :inactive-value="2" v-model="form.is_allow"> </el-switch>
    </el-form-item>
    <!-- 允许加班则展示其他配置项 -->
    <template v-if="form.is_allow === 1">
      <!-- 类型名称 -->
      <el-form-item :label="$t('1717')" :prop="formateKey('type_name')">
        <!-- 编辑状态展示 -->
        <template v-if="weekdayEditingStatus">
          <span>{{ form.type_name }}</span>
          <el-button
            @click="handlerEditTypeName"
            icon="el-icon-edit"
            class="no-color type-name"
            type="text"
          ></el-button>
        </template>
        <!-- 非编辑状态展示 -->
        <el-input
          v-model="form.type_name"
          v-else
          @blur="handlerEditTypeName"
          ref="typeName"
          :maxlength="30"
          show-word-limit
        ></el-input>
        <el-tooltip effect="dark" :content="$t('1706')" placement="right">
          <i class="el-icon-info"></i>
        </el-tooltip>
      </el-form-item>
      <!-- 可选加班日期 -->
      <el-form-item prop="is_allow" :rules="[{ validator: validatePass }]">
        <template slot="label">
          {{ $t('1718') }}
          <el-tooltip class="item" effect="dark" :content="$t('67099220')" placement="bottom-start">
            <i class="el-icon-info" style="margin: 0"></i>
          </el-tooltip>
        </template>
        <!-- 当日前 -->
        <el-checkbox :label="$t('1719')" v-model="form.is_allow_apply_date_forward">
          {{ $t('1719') }}
          <el-form-item class="time-inline" :prop="formateKey(`allow_apply_date_forward`)">
            <el-input
              class="short-input"
              type="number"
              min="1"
              v-enterIntNumber
              v-model="form.allow_apply_date_forward"
            />
          </el-form-item>
          <!-- 天 -->
          {{ $t('123') }}
        </el-checkbox>
        <!-- 当日 -->
        <el-checkbox v-model="form.allow_apply_date_this_day" :label="$t('1642')">{{ $t('1642') }}</el-checkbox>
        <!-- 当日后 -->
        <el-checkbox v-model="form.is_allow_apply_date_backward">
          {{ $t('1720') }}
          <el-form-item class="time-inline" :prop="formateKey(`allow_apply_date_backward`)">
            <el-input
              class="short-input"
              type="number"
              min="1"
              v-enterIntNumber
              v-model="form.allow_apply_date_backward"
            />
          </el-form-item>
          <!-- 天 -->
          {{ $t('123') }}
        </el-checkbox>
      </el-form-item>
      <!-- 计算方式 -->
      <el-form-item :label="$t('1780')" class="margin-0">
        <el-radio-group v-model="form.calculate_type">
          <!-- 仅以审批时长为准，无需打卡 -->
          <el-radio :label="1" class="like-form-item">{{ $t('1788') }}</el-radio>
          <!-- 以审批时长为准，但考勤时间应覆盖审批时长 -->
          <el-radio :label="2">{{ $t('1789') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 计入加班 -->
      <template v-if="ruleKey === 'working_day'">
        <!-- 上班前{x}小时计入加班 -->
        <el-form-item :prop="formateKey('allow_apply_time_interval_forward')">
          {{ $t('1781') }}
          <el-input
            class="short-input"
            v-model="form.allow_apply_time_interval_forward"
            type="number"
            v-enterNumberPoint1
            v-enterNumberMax="12"
            max="12"
            min="0"
          />
          {{ $t('1782') }}
        </el-form-item>
        <!-- 下班后{x}小时计入加班 -->
        <el-form-item :prop="formateKey('allow_apply_time_interval_backward')">
          {{ $t('1783') }}
          <el-input
            class="short-input"
            v-enterNumberPoint1
            v-enterNumberMax="12"
            v-model="form.allow_apply_time_interval_backward"
            type="number"
            max="12"
            min="0"
          />
          {{ $t('1782') }}
        </el-form-item>
      </template>

      <template v-if="ruleKey !== 'working_day'">
        <!-- 是否限制可选申请范围 -->
        <el-form-item :label="$t('1784')" :prop="formateKey('allow_apply_time_interval_backward')">
          <el-radio-group v-model="form.is_allow_apply_time">
            <el-radio :label="2">{{ $t('1813') }}</el-radio>
            <el-radio :label="1">{{ $t('1814') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 可选申请范围  非工作日加班展示 -->
        <el-form-item class="margin-0" v-if="form.is_allow_apply_time === 1">
          <el-form-item class="time-inline" :prop="formateKey(`start`)" :rules="[{ validator: validateDate }]">
            <el-time-picker
              :placeholder="$t('1101')"
              class="my-picker"
              v-model="form.start"
              format="HH:mm"
              value-format="HH:mm"
              @blur="updateData"
            />
          </el-form-item>
          ～
          <el-form-item class="time-inline" :prop="formateKey(`end`)" :rules="[{ validator: validateDate }]">
            <el-time-picker
              :placeholder="$t('1102')"
              class="my-picker"
              v-model="form.end"
              format="HH:mm"
              @blur="updateData"
              value-format="HH:mm"
            />
          </el-form-item>
          <el-tag type="small" style="margin-left: 20px" v-if="isShowNextDay">{{ $t('1592') }}</el-tag>
        </el-form-item>
      </template>

      <!-- 扣除休息时间 -->
      <el-form-item :label="$t('1775')" prop="is_deduct_rest_time" class="margin-rest">
        <el-switch v-model="form.is_deduct_rest_time" :active-value="true" :inactive-value="false"> </el-switch>
      </el-form-item>
      <!-- 开启扣除休息时间 -->
      <template v-if="form.is_deduct_rest_time">
        <el-form-item class="margin-rest">
          <el-radio-group v-model="form.deduct_rest_time">
            <!-- 设置休息时段 -->
            <el-radio :label="2">
              <span>{{ $t('1785') }}</span>
            </el-radio>
            <!-- 按加班时长扣除 -->
            <el-radio :label="3">
              {{ $t('1786') }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 设置休息时段必填 -->
        <el-form-item v-if="form.deduct_rest_time === 2">
          <ul>
            <li v-for="(item, index) in form.rest_time_period_formate" :key="index + ruleKey">
              <el-form-item
                class="time-inline"
                :rules="timeIntervalRule"
                :prop="formateKey(`rest_time_period_formate.${index}.start`)"
              >
                <el-time-picker
                  :placeholder="$t('1101')"
                  class="my-picker"
                  v-model="item.start"
                  :picker-options="timeOption"
                  format="HH:mm"
                  value-format="HH:mm"
                  @blur="updateData"
                />
              </el-form-item>
              <span> ~ </span>
              <el-form-item
                :rules="timeIntervalRule"
                class="time-inline"
                :prop="formateKey(`rest_time_period_formate.${index}.end`)"
              >
                <el-time-picker
                  :placeholder="$t('1102')"
                  class="my-picker"
                  v-model="item.end"
                  :picker-options="timeOption"
                  format="HH:mm"
                  value-format="HH:mm"
                  @blur="updateData"
                />
              </el-form-item>
              <el-button
                v-if="index > 0"
                icon="el-icon-remove"
                class="no-color"
                type="text"
                @click="handlerAddTimeInterval(index, false, 'remove')"
                :picker-options="timeOption"
              ></el-button>
              <el-button
                icon="el-icon-circle-plus"
                class="no-color"
                type="text"
                @click="handlerAddTimeInterval(index, false, 'add')"
              ></el-button>
            </li>
          </ul>
        </el-form-item>
        <!-- 按加班时长扣除 -->
        <el-form-item v-if="form.deduct_rest_time === 3">
          <ul>
            <li v-for="(item, index) in form.rest_time_rule" :key="index + ruleKey + 'b'">
              {{ $t('1787') }}
              <el-form-item
                :rules="timeIntervalRule"
                class="time-inline"
                :prop="formateKey(`rest_time_rule.${index}.over_time`)"
              >
                <el-input
                  class="short-input"
                  v-model="item.over_time"
                  type="number"
                  v-enterNumberPoint1
                  v-enterNumberMax="12"
                  max="12"
                />
              </el-form-item>
              <!-- 小时扣除 -->
              {{ $t('2889') }}
              <el-form-item
                :rules="timeIntervalRule"
                class="time-inline"
                :prop="formateKey(`rest_time_rule.${index}.rest_time`)"
              >
                <el-input
                  class="short-input"
                  v-model="item.rest_time"
                  type="number"
                  v-enterNumberPoint1
                  v-enterNumberMax="12"
                  max="12"
                />
              </el-form-item>
              <!-- 小时 -->
              {{ $t('1523') }}
              <!-- 增删 -->
              <el-button
                v-if="index > 0"
                icon="el-icon-remove"
                class="no-color"
                type="text"
                @click="handlerAddTimeInterval(index, true, 'remove')"
              ></el-button>
              <el-button
                icon="el-icon-circle-plus"
                class="no-color"
                type="text"
                @click="handlerAddTimeInterval(index, true, 'add')"
              ></el-button>
            </li>
          </ul>
        </el-form-item>
      </template>
      <!-- 加班时长限制 -->
      <el-form-item :label="$t('1633')" :prop="formateKey('mini_limit')" class="margin-0">
        {{ $t('1649') }}
        <el-input
          class="short-input"
          v-model="form.mini_limit"
          type="number"
          v-enterNumberPoint1
          v-enterNumberMax="12"
          max="12"
          min="0"
        />
        {{ $t('1648') }}
      </el-form-item>
      <el-form-item :prop="formateKey('max_limit')">
        {{ $t('1647') }}
        <el-input
          class="short-input"
          v-model="form.max_limit"
          type="number"
          v-enterNumberPoint1
          v-enterNumberMax="12"
          max="12"
          min="0"
        />
        <!-- 小时当月加班限 -->
        {{ $t('1646') }}
        <el-input
          class="short-input"
          type="number"
          v-enterNumberPoint1
          v-enterNumberMax="999"
          max="999"
          min="0"
          v-model="form.month_max_limit"
        />
        {{ $t('1523') }}
      </el-form-item>
      <!-- 当日休息满x小时 休息加班才记录 -->
      <el-form-item :prop="formateKey('is_dayoff_limit')" v-if="ruleKey === 'rest_day_overtime'">
        <el-checkbox v-model="form.is_dayoff_limit">
          <!-- 当休息日时长满 -->
          {{ $t('1645') }}
          <el-form-item class="time-inline" :prop="formateKey('dayoff_limit_ot')">
            <el-input
              class="short-input"
              v-model="form.dayoff_limit_ot"
              type="number"
              v-enterNumberPoint1
              v-enterNumberMax="12"
              max="12"
            />
          </el-form-item>
          <!-- 小时, 休息日加班才记录 -->
          {{ $t('1644') }}
        </el-checkbox>
      </el-form-item>
      <!-- 时长递增幅度 -->
      <el-form-item :label="$t('1643')">
        <el-input
          class="short-input"
          v-model="form.increment_step"
          type="number"
          v-enterNumberPoint1
          v-enterNumberMax="12"
          max="12"
          min="0.1"
          @change.native="v => handlerInput(v, { min: 0.1, max: 12 })"
        />
        <!-- 小时 -->
        {{ $t('1523') }}
        <el-tooltip effect="dark" :content="$t('1708')" placement="right">
          <i class="el-icon-info"></i>
        </el-tooltip>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import { timeIntervalRule } from './rule'
import { timeInterval, restTime } from '../enmu'

export default {
  props: {
    ruleKey: {
      type: String,
      default: ''
    },
    // 数据源
    form: {
      type: Object,
      default: () => ({})
    },
    // 时段的时间格式
    timeOption: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 时段校验
      timeIntervalRule,
      // 工作日是否处于编辑状态
      weekdayEditingStatus: true,
      // 可选加班日期至少选中一项
      validatePass: (rule, value, callback) => {
        return this.isAllow ? callback() : callback(new Error(this.$t('1812')))
      },
      // 可选申请日期校验
      validateDate: (rule, value, callback) => {
        if (!value) return callback(new Error(this.$t('221')))
        const state = this.form.start === this.form.end
        return !state ? callback() : callback(new Error(this.$t('1815')))
      }
    }
  },
  computed: {
    isAllow() {
      const { is_allow_apply_date_forward, is_allow_apply_date_backward, allow_apply_date_this_day } = this.form
      const state = [is_allow_apply_date_forward, is_allow_apply_date_backward, allow_apply_date_this_day].some(
        item => item
      )
      return state
    },
    isShowNextDay() {
      const { start, end } = this.form
      if (!start || !end) return false
      const startArr = start.split(':')
      const endArr = end.split(':')
      const startTime = new Date(2020, 0, 0, 0, startArr[0], startArr[1])
      const endTime = new Date(2020, 0, 0, 0, endArr[0], endArr[1])
      if (startTime > endTime) return true
      return false
    }
  },
  methods: {
    handlerInput(e, params) {
      if (!e) return false
      const value = e.target.value
      const { min, max } = params
      if (min && value < min) e.target.value = min
      if (max && value > max) e.target.value = max
    },
    /**
     *  时段添加删除
     *  @param { Number } index 当前下标
     *  @param { Boolean } bool 判断操作的目标对象
     *  @param { String } type 添加或删除 add or remove
     */
    handlerAddTimeInterval(index, bool, type) {
      const editKey = bool ? 'rest_time_rule' : 'rest_time_period_formate'
      const exampleObj = bool ? restTime() : timeInterval()
      type === 'add' ? this.form[editKey].splice(index + 1, 0, exampleObj) : this.form[editKey].splice(index, 1)
      this.updateData()
    },
    // 数据源更新
    updateData() {
      this.$emit('changeData', this.ruleKey, JSON.parse(JSON.stringify(this.form)))
    },
    // 类型名称编辑
    handlerEditTypeName() {
      this.weekdayEditingStatus = !this.weekdayEditingStatus
      // 主动获取焦点
      if (!this.weekdayEditingStatus) this.$nextTick(() => this.$refs.typeName.focus())
    },
    // 生成校验key
    formateKey(str) {
      return 'settings.' + this.ruleKey + '.' + str
    }
  }
}
</script>
